import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";
import ProjectNotificationBannerCarousel, {
  BannerItem,
} from "shared/components/dashboardCommon/projectNotificationBannerCarousel";
import { MarkRevisionViewedService } from "shared/services/revision";
import { ProjectDetailTabs } from "shared/utils/enum";

const CollaboratorProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);
  const navigate = useNavigate();
  const [projects, setProjects] = useState<any[]>([]);

  const handleProjectsLoaded = (loadedProjects: any[]) => {
    setProjects(loadedProjects);
  };

  const navigateToProject = (
    project: any,
    options: { tab?: ProjectDetailTabs } = {},
  ) => {
    const path = routeConstant.collaborator.projectDetail.path.replace(
      ":id",
      String(project.project_id),
    );
    navigate(options.tab ? `${path}?tab=${options.tab}` : path, {
      state: { projectData: project },
    });
  };

  const reviewItems: BannerItem[] = projects
    .filter((p: any) => p.latest_revision)
    .filter((p: any) => (p.status || "").toLowerCase() !== "completed")
    .filter((p: any) => {
      const s = (p.latest_revision?.status || "").toLowerCase();
      return s === "waiting_for_client_response" || s === "in_review";
    })
    .filter((p: any) => !p.latest_revision?.viewed_by_current_user)
    .slice()
    .sort((a: any, b: any) => {
      const aTime = new Date(
        a.latest_revision?.created_at || a.created_at || 0,
      ).getTime();
      const bTime = new Date(
        b.latest_revision?.created_at || b.created_at || 0,
      ).getTime();
      return bTime - aTime;
    })
    .map((p: any) => ({
      key: p.project_id,
      title: `🎉 ${p.name} - ${
        p.latest_revision?.title || "Latest Revision"
      } is ready for your review!`,
      // The only action: open the latest revision on Revisions & Media and
      // mark it viewed, retiring the card.
      onButtonClick: () =>
        navigateToProject(p, { tab: ProjectDetailTabs.REVISIONS_MEDIA }),
      onDismiss: () => {
        if (p.latest_revision?.revision_id) {
          MarkRevisionViewedService(Number(p.latest_revision.revision_id)).catch(
            () => {},
          );
        }
      },
    }));

  const notificationBanner =
    reviewItems.length > 0 ? (
      <ProjectNotificationBannerCarousel items={reviewItems} />
    ) : null;

  return (
    <ProjectsList
      userType="collaborator"
      pageTitle={`Welcome back, ${auth?.user?.display_name || ""}!`}
      pageDescription="Here's where your home design stands today"
      showNotificationBanner={true}
      showSearchFilter={true}
      notificationBannerContent={notificationBanner}
      EnableApiIntegration={true}
      onProjectsLoaded={handleProjectsLoaded}
      noContentMessage="You don't have any projects at the moment. Check back later."
      detailRoutePath={routeConstant.collaborator.projectDetail.path}
    />
  );
};

export default CollaboratorProjects;
